// Invoice Summary Request/Response Models

import { BehaviorSubject } from "rxjs";
import { SupplierDataSourceRequest } from "../common/common.model";
import { summaryModel } from "../summary.model";
import { AttachmentFile } from "../fileupload/fileupload";

export class InvoiceSummaryRequest extends summaryModel {


    public supplierid: number = 0;
    public factoryidlst: number[] = [];
    public datetypeid: number;
    public fromdate: any = null;
    public todate: any = null;
    public serviceTypelst: number[] = [];
    public dateTerm: any = null;
    public bookingNo: string = "";
    public statusidlst: number[] = [];
    public customerContactId: number;
    constructor() {
        super();

        this.supplierid = 0;
        this.factoryidlst = [];
        this.fromdate = null;
        this.todate = null;
        this.serviceTypelst = [];
        this.dateTerm = null;
        this.bookingNo = "";
        this.statusidlst = [];
    }
}

export interface InvoiceSubmitWithUrlsRequest {
    serviceId: number;
    customerId: number;
    comment: string;
    selectedBookingIds: number[];
    mainInvoiceFile: FileUploadUrl;
    supportingDocuments: FileUploadUrl[];
}

export interface FileUploadUrl {
    fileName: string;
    fileUrl: string;
    uniqueId: string;
}

export interface InvoiceReuploadRequest {
    invoiceId: number;
    comment: string;
    newInvoiceFiles: FileUploadUrl[];
    existingFilesToKeep: number[];
}

export interface InvoiceChangeStatusRequest {
    invoiceId: number;
    statusId: number;
    comment: string;
}

export interface SaveSupportingDocumentsRequest {
    invoiceId: number;
    documentIdsToDelete: number[];
    newDocuments: FileUploadUrl[];
}

// Response Models

export interface InvoiceSummaryResponse {
    data: InvoiceSummaryItem[];
    totalCount: number;
    index: number;
    pageSize: number;
    pageCount: number;
    result: InvoiceSummaryResult;
}





export class InvoiceSummaryItem {
    public isSelected: boolean;
    public bookingNo: string;
    public supplierName: string;
    public serviceType: string;
    public product: Array<string>;
    public serviceId: number;
    public serviceIcon: string;
    public statusId: number;
    public statusName: string;
    public statusColor: string;
    public fileurl: string;
    public statusImage: string;
    public supplierId: number;
    public inspectionResponsible: number;
    public quotationId: number;
}
export class BookingItem {
    id: number;
    inspectionId?: number;
    inspectionBookingNo?: string;
    auditId?: number;
    auditBookingNo?: string;
    labId?: number;
    labBookingNo?: string;
    serviceType: string;
}

export class InvoiceSubmitResponse {
    invoiceId: number;
    result: InvoiceSubmitResult;
    message: string;
}

export class InvoiceUploadedResponse {
    data: InvoiceUploadedItem[];
    totalCount: number;
    index: number;
    pageSize: number;
    pageCount: number;
    result: InvoiceUploadedResult;
}

export class InvoiceUploadedItem {
    id: number;
    serviceId: number;
    serviceName: string;
    statusId: number;
    statusName: string;
    customerId: number;
    customerName: string;
    comment: string;
    invoiceFiles: InvoiceFileInfo[];
    supportingDocuments: InvoiceFileInfo[];
    createdOn: string;
    createdBy: string;
    uploadedOn: string;
    uploadedBy: string;
}

export class InvoiceFileInfo {
    id: number;
    fileName: string;
    fileUrl: string;
    uniqueId: string;
}

export class InvoiceHistoryResponse {
    id: number;
    statusId: number;
    statusName: string;
    comment: string;
    createdOn: string;
    createdBy: string;
}

export class InvoiceDetailsResponse {
    id: number;
    serviceId: number;
    statusId: number;
    customerId: number;
    comment: string;
    existingFiles: InvoiceFileInfo[];
    result: InvoiceDetailsResult;
}

export class InvoiceStatusUpdateResponse {
    result: InvoiceStatusUpdateResult;
    message: string;
}

export class SupportingDocumentResponse {
    id: number;
    fileName: string;
    fileUrl: string;
    uniqueId: string;
    createdOn: string;
}

export interface SaveSupportingDocumentsResponse {
    result: SaveSupportingDocumentsResult;
    message: string;
}

// Enums

export enum InvoiceSummaryResult {
    Success = 1,
    NotFound = 2,
    Error = 3
}

export enum InvoiceSubmitResult {
    Success = 1,
    InvalidRequest = 2,
    NoBookingsSelected = 3,
    NoInvoiceFile = 4,
    Error = 5
}

export enum InvoiceUploadedResult {
    Success = 1,
    NotFound = 2,
    Error = 3
}

export class InvoiceUploadedSummaryResponse {
    data: InvoiceSummaryUploaded[];
    quotationStatuslst: InvoiceStatus[];
    result: InvoiceUploadedResult;
    totalCount: number = 0;
    index: number;
    pageSize: number;
    pageCount: number;
}



export class InvoiceSummaryUploaded {
    quotationId: number;
    statusId: number;
    statusText: string;
    serviceId: number;
    comment: string;
    quotationFileName: string;
    quotationFileUrl: string;
    uploadedByImage: string;
    uploadedBy: string;
    uploadedOn?: string | null;   // DateTime? → string or null
    isHasSupportingDocuments: boolean;
    bookingData: InvoiceServiceItem[];
    isExpanded?: boolean;
    fileName?: string;
}
export enum InvoiceDetailsResult {
    Success = 1,
    NotFound = 2,
    Error = 3
}



export class InvoiceServiceItem {
    quotationId: number;
    bookingNo: string;
    supplierName: string;
    serviceType: string;
    product: string[];
    serviceIcon?: string;
    showProducts?: boolean;
}

export enum InvoiceStatusUpdateResult {
    Success = 1,
    NotFound = 2,
    InvalidStatus = 3,
    Error = 4
}

export enum SaveSupportingDocumentsResult {
    Success = 1,
    NotFound = 2,
    Error = 3
}

// Status Master
export interface InvoiceStatus {
    id: number;
    name: string;
    isActive: boolean;
}

// Filter Model
export class InvoiceFilterModel {
    serviceId: number = 0;
    statusId: number = 0;
    customerId: number = 0;
    fromDate: Date | null = null;
    toDate: Date | null = null;
    searchText: string = '';
    index: number = 0;
    pageSize: number = 25;

    constructor() { }
}

export class InvoiceFileAttachmentData {
    id?: number;
    labBookingId?: number;
    category?: number;
    description?: string;
    uniqueId?: string;
    fileName?: string;
    fileUrl?: string;
    certificateId?: number | null;
    showUploadBtnLoader: boolean;
    FileData: AttachmentFile;
    Certificatename: string;
    CertificteTypeName: String;
}


export enum InvoiceStatusMaster {
    DecisionPending = 1,
    Rejected = 2,
    Approved = 3
}


export class InvoiceChangeStatusRequest {
    invoiceId: number;
    statusId: number;
    comment: string;
}
export class InvoiceNewMasterModel {

    supsearchRequest: SupplierDataSourceRequest;
    supInput: BehaviorSubject<string>;
    supLoading: boolean;
    public supplierList: any;

    facsearchRequest: SupplierDataSourceRequest;
    facInput: BehaviorSubject<string>;
    facLoading: boolean;
    public factoryList: any;
    serviceTypeList: any;
    serviceTypeLoading: any;
    selectedDate: string;
    selectedNumber: string;
    selectedNumberPlaceHolder: string;
    isShowColumn: boolean;
    isShowColumnImagePath: string;
    showColumnTooltip: string;
    isShowSearchLens: boolean;
    statusList: any;
    pageLoader: boolean;
    supplierName: string;
    customerName: string;
    factoryNameList: Array<string>;
    countryNameList: Array<string>;
    statusNameList: Array<string>;
    DateName: string;
    editButtonVisible: boolean;
    confirmButtonVisible: boolean;
    cancelButtonVisible: boolean;
    rescheduleButtonVisible: boolean;
    combineButtonVisible: boolean;
    splitButtonVisible: boolean;
    inspectionCompanyLoading: boolean;
    inspectionCompanyList: any;
    defaultStartDate: number;
    defaultEndDate: number;
    canUpdateBooking: boolean;
    lblDateRangeToDisplay: string;
    customerId: number;
    searchloading: boolean;
    constructor() {
        this.pageLoader = false;
        this.isShowColumn = true;
        this.supInput = new BehaviorSubject<string>("");
        this.facInput = new BehaviorSubject<string>("");
        this.supsearchRequest = new SupplierDataSourceRequest();
        this.facsearchRequest = new SupplierDataSourceRequest();
    }
}

 export class InvoiceHistoryuploadedResponse {
  quotationId: number;
  comment: string | null;
  updatedOn: string;           // DateTime → string (or Date if you prefer)
  updatedBy: string;
  updateByImage: string;
  statusId?: number | null;    // nullable in C#
  isQuotationReuploaded: boolean;
  quotatonFileUrl: string;
  bookingNo: Array<string>;
}


